<template>
  <custom-dialog :visible="visible" width="1300px" class="commodity-add-dialog" :title="model.title" v-on="$listeners">
    <div class="dialog-body">
      <div class="msg-content">
        <div class="title">{{ $t('fms_commodity_add_dialog.fa_piao_zhu_ti') }}</div>
        <ul class="msg-list">
          <li>
            <div class="key">{{ $t('fms_commodity_add_dialog.na_shui_deng_ji_hao') }}</div>
            <div class="val">{{ model.data.buyerNumber || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ $t('fms_commodity_add_dialog.qi_ye_ming_cheng') }}</div>
            <div class="val">{{ model.data.buyerName || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ $t('fms_commodity_add_dialog.dian_hua_hao_ma') }}</div>
            <div class="val">{{ model.data.buyerMobile || '-' }}</div>
          </li>
        </ul>
      </div>
      <div class="list-container">
        <div class="supplies-box">
          <div class="supplies-list">
            <ul>
              <li>
                <div class="ub formContact-title item">
                  <el-row :gutter="10" class="ub-f1">
                    <el-col :span="1">#</el-col>
                    <el-col :span="4">{{ $t('fms_commodity_add_dialog.shang_pin_bian_ma') }}/{{ $t('fms_commodity_add_dialog.kai_piao_xi_tong') }}</el-col>
                    <el-col :span="4">{{ $t('fms_commodity_add_dialog.mrkplx') }}</el-col>
                    <el-col :span="3">{{ $t('fms_commodity_add_dialog.fei_yong_lei_xing') }}</el-col>
                    <el-col :span="4">{{ $t('fms_commodity_add_dialog.shang_pin_ming_cheng') }}</el-col>
                    <el-col :span="3">{{ $t('fms_commodity_add_dialog.gui_ge_xing_hao') }}</el-col>
                    <el-col :span="2">{{ $t('fms_commodity_add_dialog.shui_lv') }}</el-col>
                    <el-col :span="2">{{ $t('fms_commodity_add_dialog.dan_wei') }}</el-col>
                    <el-col :span="1">{{ $t('Common.com_handle') }}</el-col>
                  </el-row>
                </div>
              </li>
              <li v-for="(item, index) in commodityList" :key="index">
                <div class="item ub">
                  <el-row :gutter="10" class="ub-f1">
                    <el-col :span="1">
                      <div class="index">
                        {{ index + 1 }}
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <el-input v-model="item.itemCode" style="width=100%;height=30px"></el-input>
                    </el-col>
                    <el-col :span="4">
                      <custom-select
                        code="invoice_type"
                        v-model="item.invoiceType"
                        :placeholder="index > 0 ? $t('fms_commodity_add_dialog.mo_ren_tong_shang') : $t('Common.com_please_select')"
                        width="100%"
                      ></custom-select>
                    </el-col>
                    <el-col :span="3">
                      <custom-select
                        code="bill_type"
                        v-model="item.billType"
                        :placeholder="index > 0 ? $t('fms_commodity_add_dialog.mo_ren_tong_shang') : $t('Common.com_please_select')"
                        width="100%"
                      ></custom-select>
                    </el-col>
                    <el-col :span="4">
                      <el-input v-model="item.itemName"  style="width=100%;height=30px"></el-input>
                    </el-col>
                    <el-col :span="3">
                      <el-input v-model="item.itemSpec"  style="width=100%;height=30px"></el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-input v-model.number="item.taxRate" :placeholder="index > 0 ? $t('fms_commodity_add_dialog.mo_ren_tong_shang') : ''" style="width=100%;height=30px"></el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-input v-model="item.itemUnit" :placeholder="index > 0 ? $t('fms_commodity_add_dialog.mo_ren_tong_shang') : '' "  style="width=100%;height=30px"></el-input>
                    </el-col>
                    <el-col :span="1">
                      <div class="icon-box" @click="deleteItem(index)">
                        <i class="icon icon-shanchu"></i>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </li>
            </ul>
          </div>
          <div class="add-btn" @click="addItem">
            <div style="display: inline-block">
              <i class="icon icon-add"></i>
              <span>{{ $t('Common.com_added') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onSaveScheme">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      commodityList: [],
      formItem: {
        billType: '', // 账单类型
        invoiceType: '', // 开票类型
        itemCode: '', // 商品编码/开票系统
        itemName: '', // 商品名称
        itemSpec: '', // 规格
        itemUnit: '', // 单位
        taxRate: '' // 税率
        // partnerInvoiceId: '', // 发票Id
        // partnerInvoiceItemId: '', // 发票明细Id
      }
    };
  },
  mounted: function () {
    this.addItem();
  },
  methods: {
    // 添加耗材项
    addItem: function () {
      this.commodityList.push(JSON.parse(JSON.stringify(this.formItem)));
    },
    // 删除方案项
    deleteItem: function (index) {
      this.commodityList.splice(index, 1);
    },
    onSaveScheme: function () {
      // 提交验证
      const stuffLength = this.commodityList.length;
      if (stuffLength <= '0') {
        this.$message.error(
          this.$t('fms_commodity_add_dialog.qtjspxx')
        );
        return;
      }

      // 默认同上
      const changeCommodityList = this.$formatCopyUp(this.commodityList, ['billType', 'invoiceType', 'itemUnit', 'taxRate']);
      this.commodityList = changeCommodityList;
      // 方案表单验证
      const hasEmpty = this.commodityList.find(
        t => !t.billType || !t.invoiceType || t.itemCode === '' || t.itemName === '' || t.itemSpec === '' || t.itemUnit === '' || t.taxRate === ''
      );
      if (hasEmpty) {
        this.$message.error(this.$t('fms_commodity_add_dialog.spxxqtxwz'));
        return;
      }
      // 商品编码不能重复
      // const codeArr = [];
      // const hasCodeRepeat = this.commodityList.find((item) => {
      //   let res;
      //   if (codeArr.length > 0) {
      //     res = codeArr.find(pitem => item.itemCode === pitem.itemCode);
      //   }
      //   codeArr.push(item);
      //   return res;
      // });
      // if (hasCodeRepeat) {
      //   const tips = '商品编码不能重复';
      //   this.$message.error(tips);
      //   return;
      // }
      // 型号规格不能重复
      // const specArr = [];
      // const hasSpecRepeat = this.commodityList.find((item) => {
      //   let res;
      //   if (specArr.length > 0) {
      //     res = specArr.find(pitem => item.itemSpec === pitem.itemSpec);
      //   }
      //   specArr.push(item);
      //   return res;
      // });
      // if (hasSpecRepeat) {
      //   const tips = '型号规格不能重复';
      //   this.$message.error(tips);
      //   return;
      // }

      // 税率保留两位小数
      // this.commodityList.forEach((item) => {
      //   item.taxRate = parseFloat(item.taxRate).toFixed(2);
      //   // item.partnerInvoiceId = this.model.data.partnerInvoiceId;
      // });

      // 保存更改租赁方
      this.$postJSON(apis.crmPartnerInvoiceItemBatchAdd, { items: this.commodityList, partnerInvoiceId: this.model.data.partnerInvoiceId }).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_save_success'),
            type: 'success',
          });
          this.$emit('success');
          this.visible = false;
        }
      });
    },
  }
};
</script>

<style lang="scss">
.commodity-add-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }
  .el-select {
    width: 100%;
  }
  .dialog-body {
    width: 100%;
    padding: 0 !important;
    display: flex;
    min-height: 500px;
    .msg-content {
      width: 260px;
      padding: 0 24px 40px;
      // height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .list-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
      .supplies-list {
        ul li {
          margin-top: 10px;
          margin-bottom: 10px;
          // border: 1px solid rgba(228, 228, 228, 1);
          &:first-child {
            margin-top: 0;
          }
        }
        .formContact-title {
          // height: 30px;
          // line-height: 30px;
          background: rgba(228, 228, 228, 1);
          color: #636e78;
          font-size: 12px;
          // padding: 0 10px;
        }
        .item {
          padding: 10px;
          background: rgba(245, 245, 245, 1);
          border: 1px solid rgba(228, 228, 228, 1);
          .index,
          .code {
            line-height: 32px;
            height: 32px;
            color: #6c757d;
            width: 100%;
          }

          .icon-box {
            line-height: 32px;
            width: 32px;
            // margin-left: 10px;
            text-align: center;
            .icon {
              color: #00afff;
              font-size: 14px;
              cursor: pointer;
            }
          }
        }
      }
      .add-btn {
        line-height: 50px;
        text-align: center;
        color: rgba(73, 80, 87, 1);
        font-size: 12px;
        margin: 16px 0 16px;
        height: 50px;
        background: #f6f7fb;
        border: 1px dashed rgba(53, 184, 224, 0.3);
        cursor: pointer;
        span {
          line-height: 50px;
        }
        .icon {
          color: #00afff;
          font-size: 12px;
          margin-right: 8px;
          display: inline-block;
          line-height: 50px;
          height: 50px;
          // float: left;
        }
      }
    }
  }
}
</style>
